import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import _imports_0 from '@/assets/images/icons/icon_checked.svg';
import _imports_1 from '@/assets/images/icons/icon_check.svg';
var _hoisted_1 = {
  class: "taxpayer-info"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = {
  class: "left"
};
var _hoisted_4 = {
  class: "name"
};
var _hoisted_5 = {
  class: "line"
};
var _hoisted_6 = {
  class: "label"
};
var _hoisted_7 = {
  class: "value"
};
var _hoisted_8 = {
  class: "line"
};
var _hoisted_9 = {
  class: "label"
};
var _hoisted_10 = {
  class: "value"
};
var _hoisted_11 = {
  class: "line"
};
var _hoisted_12 = {
  class: "label"
};
var _hoisted_13 = {
  class: "value"
};
var _hoisted_14 = {
  class: "right"
};
var _hoisted_15 = {
  class: "icon-checkbox",
  src: _imports_0,
  alt: ""
};
var _hoisted_16 = {
  class: "icon-checkbox",
  src: _imports_1,
  alt: ""
};
import { ref, computed } from "vue";
import Common from "@/components/dialog/src/Common.vue";
import { useUserStore } from "@/store/userStore";
import { issueInvoice } from "@/api/invoice";
import { hideLoading, showLoading } from "@/utils/loadingUtil";
import { Notify } from "@/utils/notifyUtil";
import { INVOICE_CANCEL_ERROR, INVOICE_ISSUE_DUP_ERROR, INVOICE_ISSUE_ERROR } from "@/constant/responseCode";
import { useI18n } from "vue-i18n";
import { getICDocTypeMap } from "@/constant/invoice";
export default {
  __name: 'SelectTaxpayerPopup',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: ""
    },
    shopId: {
      type: String,
      default: ""
    },
    orderType: {
      type: String,
      default: ""
    }
  },
  emits: ["update:show", "add", "success"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var userStore = useUserStore();
    var emit = __emit;
    var props = __props;
    var showPopup = computed({
      get: function get() {
        return props.show;
      },
      set: function set(val) {
        emit("update:show", val);
      }
    });
    var selected = ref(0);
    var onSelect = function onSelect(index) {
      selected.value = index;
    };
    var handleConfirm = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _userStore$getUserInf;
        var target, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              target = userStore.getTaxpayerList[selected.value];
              showLoading();
              _context.next = 4;
              return issueInvoice({
                is_save_taxpayer_info: false,
                order_id: props.orderId,
                order_type: props.orderType,
                shop_id: props.shopId,
                user_id: (_userStore$getUserInf = userStore.getUserInfo) === null || _userStore$getUserInf === void 0 ? void 0 : _userStore$getUserInf.customer_id,
                buyer: target
              });
            case 4:
              res = _context.sent;
              hideLoading();
              if (res.isOK) {
                showPopup.value = false;
                Notify.success(t("invoicingApplicationSubmitted"));
                emit("success", res.data);
              } else if (res.code === INVOICE_ISSUE_DUP_ERROR) {
                Notify.error(t("invoiceIssueDupErrorDesc"));
              } else if (res.code === INVOICE_CANCEL_ERROR) {
                Notify.error(t("invoiceCancelErrorDesc"));
              } else if (res.code === INVOICE_ISSUE_ERROR) {
                Notify.error(t("invoiceIssueErrorDesc"));
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleConfirm() {
        return _ref2.apply(this, arguments);
      };
    }();
    var onNew = function onNew() {
      showPopup.value = false;
      emit("add");
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(Common, {
        visible: showPopup.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return showPopup.value = $event;
        }),
        title: _ctx.$t('selectTaxpayerInformation'),
        "on-ok": handleConfirm,
        "on-cancel": onNew,
        "ok-text": _ctx.$t('confirm'),
        "cancel-text": _ctx.$t('newTaxpayer'),
        teleport: "body",
        "max-height": "84.8vh"
      }, {
        content: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userStore).getTaxpayerList, function (item, index) {
            var _item$trn_list$find;
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "item",
              onClick: function onClick($event) {
                return onSelect(index);
              }
            }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("tinNo")), 1), _createElementVNode("span", _hoisted_7, _toDisplayString(item.tin), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(_unref(getICDocTypeMap)()[item.id_doc_type]), 1), _createElementVNode("span", _hoisted_10, _toDisplayString(item.id_doc_no), 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("sstNo")), 1), _createElementVNode("span", _hoisted_13, _toDisplayString(((_item$trn_list$find = item.trn_list.find(function (trn) {
              return trn.tax_type === "sst";
            })) === null || _item$trn_list$find === void 0 ? void 0 : _item$trn_list$find.number) || "NA"), 1)])]), _createElementVNode("div", _hoisted_14, [_withDirectives(_createElementVNode("img", _hoisted_15, null, 512), [[_vShow, selected.value === index]]), _withDirectives(_createElementVNode("img", _hoisted_16, null, 512), [[_vShow, selected.value !== index]])])], 8, _hoisted_2);
          }), 128))])];
        }),
        _: 1
      }, 8, ["visible", "title", "ok-text", "cancel-text"])]);
    };
  }
};